import Vue from 'vue'
import VueRouter from 'vue-router'
import {Storage} from "@/Services/Storage";
import {LytningService} from "@/Services/LytningService";
import Swal from "sweetalert2";
import store from "../store/index";
import { useAppUsage } from '@/composables/useAppUsage';

// Handle NavigationDuplicated/NavigationRedirected errors silently
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        // Ignore benign router errors that occur during redirects or duplicate navigations
        const isBenign = err && (
            err.name === 'NavigationDuplicated' ||
            err.name === 'NavigationRedirected' ||
            // Fallback by message text to be extra safe across builds
            (typeof err.message === 'string' && err.message.includes('Redirected when going'))
        );
        if (!isBenign) throw err
    })
}

// Also handle replace method to prevent NavigationDuplicated/NavigationRedirected errors
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        const isBenign = err && (
            err.name === 'NavigationDuplicated' ||
            err.name === 'NavigationRedirected' ||
            (typeof err.message === 'string' && err.message.includes('Redirected when going'))
        );
        if (!isBenign) throw err
    })
}


Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "login" */ "../views/LoginView.vue")
        },
        {
            path: '/BulkInvoiceSuccess/success',
            name: 'BulkInvoiceSuccess',
            alias: ['//BulkInvoiceSuccess/success'],
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "login" */ "../views/BulkInvoiceSuccess.vue")
        },
        {
            path: '/tally-activation',
            name: 'TallyActivation',
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "tally-activation" */ "../views/TallyActivation.vue")
        },
        {
            path: '/StoreTologin',
            name: 'StoreTologin',
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "store-to-login" */ "@/views/StoreTologin.vue")
        },
        {
            path: '/userLogin',
            name: 'userLogin',
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "user-login" */ "../views/UserLoginView.vue")
        },
        {
            path: '/',
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "layout2" */ "@/components/layout/Layout2.vue"),
            children: [
                {
                    path: '/Reports',
                    name: 'Reports',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "reports" */ "@/views/FranchiseManagement/ReportsPlatform/Reports.vue")
                },

                {
                    path: '/Franchise-employee-update',
                    name: 'Franchise-employee-update',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "franchise-employee-update" */ "@/views/FranchiseManagement/FranchiseHR/FranchiseEmpEditView.vue")

                },
                {
                    path: '/Support',
                    name: 'Support',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "support" */ "@/views/FranchiseManagement/Support/Support.vue")
                },
                {
                    path: '/FranchiseSelectStore',
                    name: 'FranchiseSelectStore',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "franchise-select-store" */ "@/views/FranchiseManagement/FranchiseFinances/FranchiseSelectStore.vue")
                },
                {
                    path: '/Messages',
                    name: 'Messages',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "messages" */ "@/views/FranchiseManagement/StoreManagement/Messages.vue")
                },
                {
                    path: '/FranchiseFinance',
                    name: 'FranchiseFinance',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "franchise-finance" */ "@/views/FranchiseManagement/FranchiseFinances/FranchiseFinance.vue")
                },
                {
                    path: '/LoginStats',
                    name: 'LoginStats',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "login-stats" */ "@/views/FranchiseManagement/StoreManagement/LoginStats.vue")
                },
                {
                    path: '/StoresList',
                    name: 'StoresList',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stores-list" */ "@/views/FranchiseManagement/StoreManagement/StoresList.vue")
                },
                {
                    path: '/SelectStore',
                    name: 'SelectStore',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "select-store" */ "@/views/FranchiseManagement/Support/SelectStore.vue")
                },
                {
                    path: '/Invoices',
                    name: 'Invoices',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "franchise-invoices" */ "@/views/FranchiseManagement/invoices/FranchiseInvoices.vue")
                },
                {
                    path: '/FranchiseHR',
                    name: 'FranchiseHR',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "franchise-hr" */ "@/views/FranchiseManagement/FranchiseHR/FranchiseHR.vue")
                },
                {
                    path: '/StoreManagements',
                    name: 'StoreManagements',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "store-managements" */ "@/views/FranchiseManagement/StoreManagement/StoreManagements.vue"),
                    children: [
                        {
                            path: 'BulkInvoices',
                            name: 'BillingInvoices',
                            component: () => import(/* webpackPrefetch: true, webpackChunkName: "bulk-invoices" */ '../views/Billing/Invoices')
                        }
                    ]
                },
                {
                    path: '/Franchise-Security',
                    name: 'Franchise-Security',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "franchise-security" */ "@/views/FranchiseManagement/FranchiseHR/Franchise-Security.vue")
                },

                {
                    path: '/SuccessfulPurchace',
                    name: 'SuccessfulPurchace',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "successful-purchase" */ "@/views/SuccessfulPurchace.vue")
                },
                {
                    path: '/UnsuccesfulPurchase',
                    name: 'UnsuccesfulPurchase',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "unsuccessful-purchase" */ "@/views/UnsuccesfulPurchase.vue")
                },
                {
                    path: '/StoreLogin',
                    name: 'StoreLogin',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "store-login" */ "@/views/StoreLogin.vue")
                },
                {
                    path: '/StoreManagement',
                    name: 'StoreManagement',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "store-management" */ "@/views/StoreManagement.vue")
                },

                {
                    path: '/verifySupportLogin',
                    name: 'verifySupportLogin',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "verify-support-login" */ "@/views/verifySupportLogin.vue")
                },
                {
                    path: '/SupportOtp',
                    name: 'SupportOtp',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "support-otp" */ "@/views/SupportOtp.vue")
                },
                {
                    path: '/LoginToStore',
                    name: 'LoginToStore',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "login-to-store" */ "@/views/LoginToStore.vue")
                },
                {
                    path: '/ResetDeviceCount',
                    name: 'ResetDeviceCount',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "reset-device-count" */ "@/views/ResetDeviceCount.vue")
                },
                {
                    path: '/Create-Employee',
                    name: 'Create-Employee',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "employee-create" */ '../views/FranchiseManagement/FranchiseHR/FranchiseCreateEmp.vue'),
                },
                {
                    path: '/Edit-Employee',
                    name: 'Edit-Employee',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "employee-create" */ '../views/FranchiseManagement/FranchiseHR/FranchiseEditEmp.vue'),
                },
                {
                    path: '/Franchise-Securities',
                    name: 'Franchise-Securities',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "employee-create" */ '../views/FranchiseManagement/FranchiseHR/FranchiseEmpSecurities.vue'),
                },
            ]
        },
        {
            path: '/',
            component: () => import(/* webpackPrefetch: true, webpackChunkName: "layout" */ '../components/layout/Layout.vue'),
            children: [

                //Stock
                {
                    path: '/stock',
                    name: 'stock',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock" */ '../views/Stock/StockView.vue'),
                },
                {
                    path: '/reports/tally',
                    name: 'TallyReports',
                    meta: { title: 'Tally Reports' },
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "tally-reports" */ "@/views/Reports/TallyReports.vue")
                },
                {
                    path: '/storeCashups',
                    name: 'storeCashups',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "storeCashups" */ '../views/StoreCashups.vue'),
                },

                {
                    path: '/stock-create',
                    name: 'stock-create',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-create" */ '../views/Stock/CreateStockView.vue'),
                },

                {
                    path: '/stock-search',
                    name: 'stock-search',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-search" */ '../views/Stock/StockSearchView.vue'),
                },
                {
                    path: '/CaseHierachy',
                    name: 'case-hierarchy',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "case-hierarchy" */ '../views/Stock/Specials/CaseHierachy.vue'),
                },
                {
                    path: '/stock-edit',
                    name: 'stock-edit',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-edit" */ '../views/Stock/EditStockView.vue'),
                },

                {
                    path: '/stock-received-supplier',
                    name: 'stock-received-supplier',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-received-supplier" */ '../views/Stock/GRV/SelectSupplierView.vue'),
                },
                {
                    path: '/editItemsReceived',
                    name: 'editItemsReceived',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-received-items" */ '../views/Stock/GRV/editItemsReceived.vue'),
                },

                {
                    path: '/stock-receive-items',
                    name: 'stock-receive-items',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-received-items" */ '../views/Stock/GRV/SelectItemsReceived.vue'),
                },
                {
                    path: '/resume-saved-grv',
                    name: 'resume-saved-grv',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-received-items" */ '../views/Stock/GRV/SelectSavedGrvItemsReceived.vue'),
                },
                {
                    path: '/smart-invoice-grv',
                    name: 'smart-invoice-grv',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "smart-invoice-grv" */ '../views/Stock/GRV/SmartInvoiceGRVs'),
                },

                {
                    path: '/stock-take',
                    name: 'stock-take',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-take" */ '../views/Stock/StockTake/StockTakeView.vue'),
                },

                {
                    path: '/stock-recipes',
                    name: 'stock-recipes',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-recipes" */ '../views/Stock/links/recipes/StockRecipesView.vue'),
                },

                {
                    path: '/cooking-instructions',
                    name: 'cooking-instructions',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "cooking-instructions" */ '../views/Stock/links/CookingInstructionSetupView'),
                },

                {
                    path: '/view-purchase-orders',
                    name: 'view-purchase-orders',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "view-purchase-orders" */ '../views/Stock/PurchaseOrdersView'),
                },
                {
                    path: '/view-gate-entry',
                    name: 'view-gate-entry',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "view-gate-entry" */ '../views/Stock/GRV/GateEntryItemsView'),
                },

                {
                    path: '/stock-cases/',
                    name: 'stock-cases',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-cases" */ '../views/Stock/links/cases/StockCaseLinkView.vue'),
                },

                {
                    path: '/stock-cooking-instructions',
                    name: 'stock-cooking-instructions',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-cooking-instructions" */ '../views/Stock/StockView.vue'),
                },

                {
                    path: '/stock-categories-search',
                    name: 'stock-categories-search',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-categories-search" */ '../views/Stock/Categories/ViewCategories.vue'),
                },
                {
                    path: '/stock-adjustment',
                    name: 'stock-adjustment',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-adjustment" */ '../views/Stock/AdjustStockView.vue'),
                },

                {
                    path: '/stock-production',
                    name: "stock-production",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-production" */ '../views/Stock/ProductionView.vue')
                },
                {
                    path: '/PaymentMethods',
                    name: 'PaymentMethods',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "PaymentMethods" */ '../views/Finance/PaymentMethods'),
                },
                {
                    path: '/specials',
                    name: "specials",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "Special" */ '../views/Stock/Specials/Specials.vue')
                },

                {
                    path: '/FranchiseEmployeeType',
                    name: "FranchiseEmployeeType",
                    component: () => import(/* webpackPrefetch: true , webpackChunkName: "Special" */ '../views/FranchiseManagement/FranchiseHR/FranchiseEmployeeType.vue'),
                    props: (route) => ({
                        groupId: route.query.group,
                        group: route.params.group
                    })
                },
                {
                    path: '/discountSpecial/:id',
                    name: "discountSpecial",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "discountSpecial" */ '../views/Stock/Specials/discountSpecial.vue')
                },
                {
                    path: '/multiSpecial/:id',
                    name: "multiSpecials",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "multiSpecials" */ '../views/Stock/Specials/multiSpecial.vue')
                },
                {
                    path: '/comboSpecial/:id',
                    name: "comboSpecial",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "comboSpecial" */ '../views/Stock/Specials/comboSpecial.vue')
                },
                {
                    path: '/create-special',
                    name: "create-special",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "create-special" */ '../views/Stock/Specials/CreateSpecials.vue')
                },
                {
                    path: '/specials-edit',
                    name: "specials-edit",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "specials-edit" */ '../views/Stock/Specials/SpecialsEdit.vue')
                },
                {
                    path: '/mass-price-edit',
                    name: "mass-price-edit",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "mass-price-edit" */ '../views/Stock/MassPriceEditorView.vue')
                },
                {
                    path: '/MassStockUpdate',
                    name: "MassStockUpdate",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "mass-price-edit" */ '../views/Stock/MassStockUpdate.vue')
                },

                {
                    path: '/stock-conversion',
                    name: "stock-conversion",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-conversion" */ '../views/Stock/StockConversionView.vue')
                },
                //Debtors
                {
                    path: '/debtor-create',
                    name: 'debtor-create',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "debtor-create" */ '../views/Debtors/CreateDebtorView.vue'),
                },
                {
                    path: '/pre-loyalty',
                    name: 'pre-loyalty',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "pre-loyalty" */ '../views/Debtors/Loyalty/pre-loyalty.vue'),
                },

                {
                    path: '/main-debtors',
                    name: 'main-debtors',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "main-debtors" */ '../views/Debtors/MainDebtor/MainDebtorsView'),
                },
                {
                    path: '/Layby',
                    name: 'Layby',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "main-debtors" */ '../views/Debtors/Layby/Layby'),
                },
                {
                    path: '/lay-by-customer',
                    name: 'lay-by-customer',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "lay-by-customer" */ '../views/Debtors/Layby/LaybyCustomer'),
                },

                {
                    path: '/Loyalty',
                    name: 'Loyalty',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "main-debtors" */ '../views/Debtors/Loyalty/Loyalty'),
                },
                {
                    path: '/DebtorSafe',
                    name: 'DebtorSafe',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "DebtorSafe" */ '../views/Finance/DebtorSafe'),
                },

                {
                    path: '/edit-main-debtor',
                    name: 'edit-main-debtor',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "edit-main-debtor" */ '../views/Debtors/MainDebtor/EditMainDebtorView'),
                },

                {
                    path: '/debtor-search',
                    name: 'debtor-search',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "debtor-search" */ '../views/Debtors/DebtorSearchView.vue'),
                },

                {
                    path: '/debtor-update',
                    name: 'debtor-update',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "debtor-update" */ '../views/Debtors/ViewDebtorScreen.vue'),
                },
                {
                    path: '/invoice-delivery-note',
                    name: 'invoice-delivery-note',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "invoice-delivery-note" */ '../views/Debtors/DeliveryNotes/ViewDeliveryNote'),
                },

                {
                    path: '/quotes',
                    name: 'quotes',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "quotes" */ '../views/Debtors/QuotesView.vue'),
                },
                {
                    path: '/view-invoices',
                    name: 'ViewInvoices',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "ViewInvoices" */ '../views/Debtors/ViewInvoices'),
                },
                {
                    path: '/pointOfPayment',
                    name: 'pointOfPayment',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "pointOfPayment" */ '../views/Debtors/pointOfPayment'),
                },
                {
                    path: '/DeliveryNotes',
                    name: 'DeliveryNotes',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "pointOfPayment" */ '../views/Debtors/DeliveryNotes'),
                },
                {
                    path: '/createExpenseCategory',
                    name: 'createExpenseCategory',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "quotes" */ '../views/Finance/createExpenseCategory.vue'),
                },
                {
                    path: '/viewExpensecategories',
                    name: 'viewExpensecategories',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "quotes" */ '../views/Finance/viewExpensecategories.vue'),
                },
                {
                    path: '/viewExpenseRecords',
                    name: 'viewExpenseRecords',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "quotes" */ '../views/Finance/viewExpenseRecords.vue'),
                },
                //Suppliers
                {
                    path: '/supplier-create',
                    name: 'supplier-create',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "supplier-create" */ '../views/Suppliers/CreateSupplierView.vue'),
                },
                {
                    path: '/GRV',
                    name: 'GRV',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-received-items" */ '../views/Stock/GRV/grvtest.vue'),
                },

                {
                    path: '/supplier-search',
                    name: 'supplier-search',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "supplier-search" */ '../views/Suppliers/SelectSupplierView.vue'),
                },

                {
                    path: '/supplier-update',
                    name: 'supplier-update',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "supplier-update" */ '../views/Suppliers/ViewSupplierScreen.vue'),
                },

                //employee

                {
                    path: '/employee-create',
                    name: 'employee-create',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "employee-create" */ '../views/Employees/EmpAddView.vue'),
                },

                {
                    path: '/employee-search',
                    name: 'employee-search',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "employee-search" */ '../views/Employees/EmployeesView.vue'),
                },
                {
                    path: '/Float-screen',
                    name: 'Float-screen',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "float-screen" */ '../views/Employees/Float-screen.vue'),
                },

                {
                    path: '/employee-update',
                    name: 'employee-update',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "employee-update" */ '../views/Employees/EmpEditView.vue'),
                },

                // Security Management - Single multi-step page
                {
                    path: '/security',
                    name: 'security-management',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "security-management" */ '../views/Employees/Security/SecurityManagementView.vue'),
                },

                // Legacy security routes for backward compatibility
                {
                    path: '/employee-security',
                    name: 'employee-security',
                    redirect: { name: 'security-management' }
                },
                {
                    path: '/employee-security-type',
                    name: 'employee-security-type',
                    redirect: { name: 'security-management' }
                },
                {
                    path: '/employee-security-update',
                    name: 'employee-security-update',
                    redirect: { name: 'security-management' }
                },

                // Legacy improved security routes for backward compatibility
                {
                    path: '/security-groups',
                    name: 'security-groups',
                    redirect: { name: 'security-management' }
                },
                {
                    path: '/security/group/:groupName',
                    name: 'security-types',
                    redirect: { name: 'security-management' }
                },
                {
                    path: '/security/group/:groupName/type/:typeName',
                    name: 'security-permissions',
                    redirect: { name: 'security-management' }
                },

                //Transfer
                {
                    path: '/stock-transfer',
                    name: "stock-transfer",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "stock-transfer" */ '../views/Stock/StockTransfer/SelectTransferTypeView.vue'),
                },
                {
                    path: '/create-missing-item',
                    name: "create-missing-item",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "create-missing-item" */ '../views/Stock/StockTransfer/CreateMissingItem'),
                },

                {
                    path: '/incoming-stock-transfer',
                    name: "incoming-stock-transfer",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "incoming-stock-transfer" */ '../views/Stock/StockTransfer/IncomingTransfersView.vue'),
                },

                {
                    path: '/rejected-stock-transfer',
                    name: "rejected-stock-transfer",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "rejected-stock-transfer" */ '../views/Stock/StockTransfer/RejectedTransfersView.vue'),
                },

                {
                    path: '/saved-stock-transfer',
                    name: "saved-stock-transfer",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "saved-stock-transfer" */ '../views/Stock/StockTransfer/SavedTransfersView.vue'),
                },

                {
                    path: '/not-received-transfer',
                    name: "not-received-transfer",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "not-received-transfer" */ '../views/Stock/StockTransfer/NotReceivedTransfersView.vue'),
                },

                {
                    path: '/view-stock-transfer',
                    name: "view-stock-transfer",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "view-stock-transfer" */ '../views/Stock/StockTransfer/ViewTransferView.vue'),
                },

                {
                    path: '/transfer-items',
                    name: "transfer-items",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "transfer-items" */ '../views/Stock/StockTransfer/ViewItemsToSendView.vue'),
                },
                {
                    path: '/StockArchive',
                    name: "StockArchive",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "transfer-items" */ '../views/Stock/StockArchive.vue'),
                },
                {
                    path: '/transfer-items-search',
                    name: "transfer-items-search",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "transfer-items-search" */ '../views/Stock/StockTransfer/SearchSendingItemsView.vue'),
                },

                {
                    path: '/select-receiving-store',
                    name: "select-receiving-store",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "select-receiving-store" */ '../views/Stock/StockTransfer/SelectReceivingStoreView.vue'),
                },
                {
                    path: '/AssetCategories',
                    name: "AssetCategories",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "select-receiving-store" */ '../views/Finance/AssetCategories.vue'),
                },
                {
                    path: '/AssetRecords',
                    name: "AssetRecords",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "select-receiving-store" */ '../views/Finance/AssetRecords.vue'),
                },

                {
                    path: '/select-cooking-instructions',
                    name: "select-cooking-instructions",
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "select-cooking-instructions" */ '../views/Stock/StockTransfer/CookingInstruction.vue'),
                },
                {
                    path: '/CreateExpenseCategory',
                    name: 'CreateExpenseCategory',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "CreateExpenseCategory" */ '../components/Finance/CreateExpenseCategory.vue'),
                },
                //Finance
                {
                    path: '/KazangOptions',
                    name: 'KazangOptions',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "finance-select" */ '../views/Finance/KazangOptions.vue'),
                },
                {
                    path: '/ResetAccount',
                    name: 'ResetAccount',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "finance-select" */ '../views/Finance/ResetAccount.vue'),
                },
                {
                    path: '/Acknowledgement',
                    name: 'Acknowledgement',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "finance-select" */ '../views/Acknowledgement.vue'),
                },
                {
                    path: '/KazangRecords',
                    name: 'KazangRecords',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "finance-select" */ '../views/Finance/KazangRecords.vue'),
                },
                {
                    path: '/KazangSignup',
                    name: 'KazangSignup',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "finance-select" */ '../views/Finance/KazangSignup.vue'),
                },
                {
                    path: '/smart-invoicing-setup',
                    name: 'smart-invoicing-setup',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "smart-invoicing-setup" */ '../views/Finance/Smart-invoicing-setup.vue'),
                }, {
                    path: '/finance-select',
                    name: 'finance-select',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "finance-select" */ '../views/Finance/FinanceSelectView.vue'),
                },
                {
                    path: '/currency',
                    name: 'currency',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "currency" */ '../views/Finance/CurrencySetupView'),
                },

                //Safes
                {
                    path: '/safe-search',
                    name: 'safe-search',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "safe-search" */ '../views/Finance/Safes/SafeSearchView.vue'),
                },

                {
                    path: '/view-safe',
                    name: 'view-safe',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "view-safe" */ '../views/Finance/Safes/SafeView.vue'),
                },
                {
                    path: '/subscription-accounts',
                    name: 'subscription-accounts',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "subscription-accounts" */ '../views/Billing/SubscriptionsAndAccountsView'),
                },

                {
                    path: '/customer-quotes',
                    name: 'customer-quotes',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "customer-quotes" */ '../views/Billing/CustomerQuotes'),
                },

                {
                    path: '/Lyt-SoftApps',
                    name: 'Lyt-SoftApps',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "Lyt-SoftApps" */ '../views/Lyt-softApps/Lyt-SoftApps.vue'),
                },
                {
                    path: '/email-setup/:mainCustomerID',
                    name: 'email-setup',
                    component: () => import(/* webpackChunkName: "email-setup" */ '../views/Settings/EmailSetupView')
                },
                {
                    path: '/SystemSettings',
                    name: 'SystemSettings',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "SystemSettings" */ '../views/Settings/SystemSettings.vue'),
                },
                {
                    path: '/SystemAdjustments',
                    name: 'SystemAdjustments',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "SystemAdjustments" */ '../views/Settings/SystemAdjustments.vue'),
                },
                {
                    path: '/Labelsetup',
                    name: 'Labelsetup',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "SystemAdjustments" */ '../views/Settings/Labelsetup.vue'),
                },
                {
                    path: '/Ticket',
                    name: 'Create-Ticket',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "create-ticket" */ '../views/Tickets/Ticket.vue'),
                },
                {
                    path: '/ViewOpenTicket',
                    name: 'ViewOpenTicket',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "SystemAdjustments" */ '../views/Tickets/ViewOpenTicket.vue'),
                },
                {
                    path: '/smart-invoice-imports',
                    name: 'smart-invoice-imports',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "smart-invoice-imports" */ '../views/Stock/GRV/IncomingImportsView'),
                },
                {
                    path: '/create-manual-ledger-entry',
                    name: 'create-manual-ledger-entry',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "create-manual-ledger-entry" */ '../views/Finance/ManualLedgerEntryView'),
                },

                {
                    path: '/RestAccount',
                    name: 'RestAccount',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "RestAccount" */ '../views/Finance/ResetAccount.vue'),
                },
                {
                    path: '/UpdateKazangDetails',
                    name: 'UpdateKazangDetails',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "UpdateKazangDetails" */ '../views/Finance/UpdateKazangDetails.vue'),
                },
                {
                    path: '/ZedMobileSetup',
                    name: 'ZedMobileSetup',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "ZedMobileSetup" */ '../views/Finance/ZedMobileSetup.vue'),
                },
                {
                    path: '/LoyaltySetup',
                    name: 'LoyaltySetup',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "ZedMobileSetup" */ '../views/Loyalty/LoyaltySetup.vue'),
                },
                {
                    path: '/LoyaltyCustomers',
                    name: 'LoyaltyCustomers',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "ZedMobileSetup" */ '../views/Loyalty/LoyaltyCustomers.vue'),
                },
                {
                    path: '/ViewClosedTicket',
                    name: 'ViewClosedTicket',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "ViewClosedTicket" */ '../views/Tickets/ViewClosedTicket.vue'),
                },
                {
                    path: '/ticket/:id',
                    name: 'TicketDetail',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "TicketDetail" */ '../views/Tickets/TicketDetails.vue'),
                    // component: TicketDetail,
                },
                {
                    path: '/InvoiceRecords',
                    name: 'InvoiceRecords',
                    component: () => import(/* webpackPrefetch: true, webpackChunkName: "InvoiceRecords" */ '../components/point-of-sale/sales/Invoices/InvoiceRecords.vue'),
                },
                {
                    path: '/sap/invoices/dashboard',
                    name: 'SapInvoiceDashboard',
                    component: () => import(/* webpackChunkName: 'sap-invoice-dashboard' */ '../views/SAP/SapInvoiceDashboard.vue'),
                    beforeEnter: async (to, from, next) => {
                        try {
                            const store = to.router?.app?.$store || require('../store').default;
                            // Fast path: if store flag already indicates SAP, allow immediately
                            if (store.getters['settings/isCurrentStoreSapRegistered']) return next();
                            // Ensure SAP key check has run (mirrors ViewInvoices)
                            await store.dispatch('integrations/sap/fetchSapApiKey').catch(() => {});
                            const allowed = store.getters['settings/isCurrentStoreSapRegistered'];
                            if (!allowed) return next({ name: 'SystemSettings' });
                            next();
                        } catch (e) {
                            next({ name: 'SystemSettings' });
                        }
                    }
                },
                {
                    path: '/sage300/invoices/dashboard',
                    name: 'Sage300InvoiceDashboard',
                    component: () => import(/* webpackChunkName: 'sage300-invoice-dashboard' */ '../views/Sage300/Sage300InvoiceDashboard.vue'),
                    beforeEnter: async (to, from, next) => {
                        try {
                            const store = to.router?.app?.$store || require('../store').default;
                            // Fast path: if store flag already indicates Sage 300, allow immediately
                            if (store.getters['settings/isCurrentStoreSage300Registered']) return next();
                            // Ensure Sage 300 key check has run
                            await store.dispatch('integrations/sage300/fetchSage300ApiKey').catch(() => {});
                            const allowed = store.getters['settings/isCurrentStoreSage300Registered'];
                            if (!allowed) return next({ name: 'SystemSettings' });
                            next();
                        } catch (e) {
                            next({ name: 'SystemSettings' });
                        }
                    }
                },
            ]
        },

    ]
})
router.beforeEach(async (to, from, next) => {

    // App Usage Tracking - track page views for authenticated users
    const { queueEvent, setUser } = useAppUsage()
    const currentUser = store.getters.getCurrentUser
    const isAuthenticated = currentUser && (currentUser.UserID || currentUser.id) &&
      currentUser.Username && String(currentUser.Username).trim().length > 0
    if (store.getters.isHydrated && isAuthenticated) {
      const userId = currentUser.UserID || currentUser.id
      setUser(userId)
      queueEvent('page:' + to.name, 'view')
    }

    // ---- Deeplink session handler (replaces legacy ?auth= flow) ----
    // Retail POS opens BackOffice with `?session=<id>&store=<DB>&page=<name>`.
    // The sessionId is opaque (no password in the URL); we hydrate via
    // GET /posAuth/{DB}/session/{id} on the Franchise Tomcat API.
    // On success we redirect to the requested page; on failure we
    // fall through to the password UI like any other unauthenticated visit.
    let sessionId = to.query.session;
    if (sessionId) {
        // eslint-disable-next-line no-console
        console.log('[deeplink][router.beforeEach] session param detected', {
            sessionIdPrefix: String(sessionId).slice(0, 8) + '...',
            store: to.query.store,
            page: to.query.page,
            toName: to.name
        });
        try {
            const storeParam = to.query.store || '';
            const pageParam = to.query.page || 'stock';
            const result = await store.dispatch('hydrateFromDeeplinkSession', {
                sessionId: String(sessionId),
                storeDB: String(storeParam)
            });
            // eslint-disable-next-line no-console
            console.log('[deeplink][router.beforeEach] hydrate result', result);
            // Strip the deeplink params from the URL so a refresh does
            // not re-trigger hydration.
            try {
                const clean = new URL(window.location.href);
                clean.searchParams.delete('session');
                clean.searchParams.delete('store');
                clean.searchParams.delete('page');
                window.history.replaceState({}, document.title, clean.toString());
            } catch (_) { /* best-effort */ }
            if (result && result.ok) {
                // eslint-disable-next-line no-console
                console.log('[deeplink][router.beforeEach] redirecting to page', { pageParam });
                return next({ name: pageParam });
            }
            // eslint-disable-next-line no-console
            console.warn('[deeplink][router.beforeEach] hydration failed - falling through to login', {
                reason: result && result.reason
            });
            // Fall through to the rest of the guard so the password UI
            // renders. Pass `next()` with no args to continue.
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('[deeplink][router.beforeEach] threw', e);
        }
    }

    let auth = to.query.auth;
    if (auth){
        try {
            localStorage.clear();
            $utils.showLoading()
            let loginData = window.atob(auth);
            loginData = JSON.parse(loginData);

            let deviceID = loginData.device;
            await Storage.setDeviceID(deviceID);

            let mobile = loginData.mobileUser;
            let isAndroid = !!loginData.isAndroid;
            let defaultStore = loginData.store;
            let user = loginData.user;
            let page = loginData.page;
            if (!page) page = {name: 'stock'};
            await store.dispatch(`mobileUserLogin`,mobile);
            await store.dispatch(`loginToStore`,defaultStore);
            await store.dispatch(`getAllUsers`)
            await store.dispatch(`validateUser`,user);
            await Storage.setAndroid(isAndroid);
            next(page)
        }finally {
            $utils.hideLoading()
        }

    }else if (to.name !== 'login' && to.name !== 'StoreManagement'
        && to.name !== 'Create-Employee'&& to.name !== 'Edit-Employee'
        && to.name !== 'Franchise-Securities'&& to.name !== 'Franchise-employee-update'
        && to.name !== 'Franchise-employee-update'&& to.name !== 'StoreManagement'
        && to.name !== 'Franchise-Security'&& to.name !== 'FranchiseEmployeeType'
        && to.name !== 'LoginToStore'&& to.name !== 'StoreLogin'
        && to.name !== 'SuccessfulPurchace'&& to.name !== 'UnsuccesfulPurchase'
        && to.name !== 'Reports'&& to.name !== 'FranchiseHR'
        && to.name !== 'StoreManagement'&& to.name !== 'StoreManagements'
        && to.name !== 'Support'&& to.name !== 'FranchiseSelectStore'
        && to.name !== 'Invoices'&& to.name !== 'Invoices'
        && to.name !== 'BulkInvoiceSuccess'
        && to.name !== 'StoresList'&& to.name !== 'FranchiseFinance'
        && to.name !== 'LoginStats'&& to.name !== 'Messages'
        && to.name !== 'SelectStore'&& to.name !== 'StoreTologin'
        && to.name !== 'StoreTologin'){
        let mobileUser = await Storage.getMobileUser();

        // Check if user has Lyt-ning subscription on every navigation
        if (mobileUser && mobileUser.mainCustomerID) {
            try {
                const hasLytning = await LytningService.checkLytningSubscription(mobileUser.mainCustomerID);
                if (hasLytning) {
                    await Swal.fire({
                        title: 'Lyt-ning Subscription Detected',
                        icon: 'warning',
                        html: '<p>Your account is on the Lyt-ning platform.</p><p>Please use the Lytning platform to access your stores.</p><p>You will now be logged out.</p>',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                    const storeInstance = router.app?.$store || store;
                    await storeInstance.dispatch('clearStoreState');
                    return next({name: 'login'});
                }
            } catch (error) {
                console.error('Lytning subscription check failed:', error);
            }
        }

        let currentStoreData = await Storage.getCurrentStore();
        let storeUser = await Storage.getCurrentUser();
        if (!mobileUser) {
            return Promise.all([
                responses.showWarning(`Please Login!`),
                next({name: 'login'})
            ]);
        }
        if (!currentStoreData) {
            // Check if this is a Franchise route - allow access without store selection
            const isFranchiseRoute = to.name && (
                    to.name.includes('Franchise') ||
                    to.name === 'franchise' ||
                    to.name === 'FranchiseManagement') ||
                to.path.includes('franchise');
            // Explicitly allow key Franchise HR child routes that do not include "Franchise" in their names
            const franchiseHrChildRoutes = ['Create-Employee', 'Edit-Employee'];
            const allowWithoutStore = isFranchiseRoute || (to.name && franchiseHrChildRoutes.includes(to.name));
            if (allowWithoutStore) {
                next();
                return;
            }
            return Promise.all([
                responses.showWarning(`Please Login!`),
                next({name: 'login'})
            ]);
        } else if (!storeUser && to.name !== 'userLogin') {
            return Promise.all([
                responses.showWarning(`User logged out Please Login!`),
                next({name: 'userLogin'})
            ]);
        } else {
            // Check if THE CURRENT store is on Lyt-ning platform
            // Only block if the specific store is Lyt-ning, allow all other stores
            try {
                const currentStore = await Storage.getCurrentStore();
                if (currentStore && currentStore.mainCustomerID) {
                    const mainCustomerID = currentStore.mainCustomerID;
                    const customerId = currentStore.CustomerID;

                    if (customerId) {
                        const isLytningStore = await LytningService.isStoreLytning(mainCustomerID, customerId);

                        if (isLytningStore) {
                            const storeName = currentStore.StoreName || currentStore.name || currentStore.storeName || 'This store';
                            // Show warning message
                            await Swal.fire({
                                title: 'Lyt-ning Store Detected',
                                icon: 'warning',
                                html: `<p>${storeName} is on the Lyt-ning platform.</p><p>Please use the Lytning platform to access this store.</p><p>You will now be logged out.</p>`,
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#3085d6',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            });

                            // Clear state and logout
                            const storeInstance = router.app?.$store || store;
                            await storeInstance.dispatch('clearStoreState');

                            // Use next() to redirect instead of router.push()
                            return next({name: 'login'});
                        }
                    }
                }
            } catch (error) {
                // If check fails, log error but allow user to proceed
                console.error('Lyt-ning store check failed:', error);
            }

            next();
        }
    }else next();
})


export default router
